module.exports = __webpack_public_path__ + "static/media/Company_Profile_BSP_2021.35433117.pdf";